import React from 'react';

import { LayoutRenderer } from './types';

export const HeroTwoLayout: LayoutRenderer = ({ children }) => {
  const nodes = React.Children.toArray(children).filter(Boolean).slice(0, 2);

  if (nodes.length === 0) return null;

  return (
    <div className="itv-row-collection__hero2-grid">
      {nodes.map((tile, index) => (
        <div
          key={`hero2-cell-${index}`}
          className={`itv-row-collection__hero2-tile ${
            index === 0 ? 'itv-row-collection__hero2-tile--primary' : 'itv-row-collection__hero2-tile--secondary'
          }`}
        >
          {tile}
        </div>
      ))}
    </div>
  );
};
